module.exports = __webpack_public_path__ + "img/tarj2-4.62d9da62.svg";